/* Coria lazy loader (v19.7): chatul si robotul se incarca la primul gest (atingere, derulare, tasta, mouse)
   sau cand browserul e liber dupa incarcarea paginii - nu in timpul incarcarii (viteza / Lighthouse).
   In tema: <script type="coria/lazy" data-src="..."></script> in ordinea dorita + acest fisier cu defer.
   Daca clienta apasa butonul chatului inainte, se incarca imediat si chatul se deschide. */
(function () {
  'use strict';
  if (window.__coriaLazyLoader) return;
  window.__coriaLazyLoader = true;
  var started = false, wantOpen = false;
  var EVENTS = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'mousemove', 'wheel'];

  function loadAll() {
    if (started) return;
    started = true;
    EVENTS.forEach(function (e) { window.removeEventListener(e, loadAll, true); });
    var tags = [].slice.call(document.querySelectorAll('script[type="coria/lazy"][data-src]'));
    var i = 0;
    (function next() {
      if (i >= tags.length) { done(); return; }
      var t = tags[i++], s = document.createElement('script');
      s.src = t.getAttribute('data-src');
      s.async = false;
      s.onload = s.onerror = next;
      document.body.appendChild(s);
    })();
  }
  function done() {
    /* chatul si robotul pornesc singure cand documentul e deja incarcat (nu emitem evenimente false) */
    if (!wantOpen) return;
    var n = 0;
    (function open() {
      if (window.CoriaWidget && typeof window.CoriaWidget.open === 'function') { try { window.CoriaWidget.open(); } catch (_) {} return; }
      if (++n < 40) setTimeout(open, 100);
    })();
  }
  /* clic pe butonul chatului inainte sa fie incarcat: tinem minte si deschidem dupa incarcare */
  document.addEventListener('click', function (e) {
    if (started && window.CoriaWidget) return;
    var t = e.target && e.target.closest && e.target.closest('#coria-fab, [data-coria-open], [data-coria-product-question]');
    if (!t) return;
    wantOpen = true;
    if (!window.CoriaWidget) { e.preventDefault(); e.stopPropagation(); }
    loadAll();
  }, true);
  EVENTS.forEach(function (e) { window.addEventListener(e, loadAll, { capture: true, passive: true, once: true }); });
  /* fara niciun gest: cand browserul e liber, la ~6 s dupa ce pagina s-a incarcat complet */
  function idleStart() {
    var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };
    setTimeout(function () { ric(loadAll, { timeout: 4000 }); }, 6000);
  }
  if (document.readyState === 'complete') idleStart(); else window.addEventListener('load', idleStart, { once: true });
})();
